<style lang="scss" scoped>
@import '../../../sass/variables';
@import '../../../sass/mixins';

  .loading {
    cursor: progress;
  }

  .create-leads-radio-text {
    @include salesflow-text($font-weight: 500);
  }

  p {
    line-height: 22px;

    &.dark {
      color: $gray-black;
    }
  }

  a.external {
    color: #00acac;
  }

  .modal-import-title {
    small {
      margin-left: 5px;
    }
  }

  .btn-cancel {
    margin-right: 0.5rem;
  }

  .btn-light {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    padding: 12px 18px;
    gap: 8px;
    border: 1px solid #886AF8;
    border-radius: 14px;
    color: $salesflow-primary;
  }
  .btn-light:hover,
  .btn-light.hover {
    color: $white;
    background-color: $salesflow-primary;
    border-color: $salesflow-primary;
  }
  .btn-light.disabled,
  .btn-light:disabled {
    color: #130f1a99;
    background-color: #f8f9fa;
    border-color: #f8f9fa;
  }

  input[type='radio'],
  input[type='checkbox'] {
    display: none; /* Esconde os inputs */
  }

  label {
    cursor: pointer;
  }

  input[type='radio'] + label:before,
  input[type='checkbox'] + label:before {
    border: 1px solid $purple;
    content: '\00a0';
    display: inline-block;
    font: 16px/1em sans-serif;
    height: 16px;
    margin: 0 12px 0 0;
    padding: 0;
    // vertical-align: top;
    width: 16px;
    border-radius: 8px;
  }

  input[type='radio']:checked + label:before,
  input[type='checkbox']:checked + label:before {
    background: $purple;
    color: $white-gray-2;
    content: '\2713';
    text-align: center;
  }

  input[type='radio']:checked + label:after,
  input[type='checkbox']:checked + label:after {
    font-weight: bold;
  }
</style>

<style lang="scss">
  @import '../../../sass/variables';
  @import '../../../sass/mixins';

  #modal-import-form {
    @media (min-width: 576px) {
      .modal-dialog {
        max-width: 524px;
      }
    }

    .modal-dialog {
      border-radius: 16px;
      overflow: hidden;
    }
  }

  #modal-import-form___BV_modal_content_,
  #modal-import-fields___BV_modal_content_ {
    @include salesflow-text(
      $color: $salesflow-font-gray,
      $font-weight: 500
    );

    .modal-header {
      padding: 16px 24px;
      @include salesflow-text($color: $white, $font-weight: 500);

      .modal-title {
        font-size: 12px;
        font-weight: 400;
      }

      .modal-title b {
        font-size: 12px;
        font-weight: 600;
      }
    }

    .modal-body,
    .modal-footer {
      background-color: $salesflow-bg-content !important;
      padding: 24px;

      &.modal-footer {
        margin-top: -1px;
      }

      #text-import-lead {
        text-align: -webkit-center;

        b {
          font-weight: 700;
          color: $salesflow-font-dark;
        }
      }

      .dropzone {
        background-color: $salesflow-bg-body;
        margin: 32px 46px 24px;
        border-radius: 16px;
        border: 1px dashed $salesflow-outline-gray-medium;
        padding: 20px 20px 8px;

        .dropzone-icon {
          display: flex;
          width: 68px;
          height: 68px;
          box-shadow: 0px 8px 24px rgba(0, 0, 0, 0.1);
          align-items: center;
          justify-content: center;
          border-radius: 100%;
          margin: 12px auto 40px auto;
          color: #212529;
          background-color: $white;
          font-size: 1.25rem;
          font-weight: 300;
        }

        .dz-message {
          text-align: center;
        }
      }

      #lead-import-middle-text {
        width: 364px;
        margin-left: 48px;
        margin-right: 48px;
        margin-bottom: 24px;
      }

      #lead-import-help {
        width: 366px;
        margin-left: 35px;
        margin: 0px 35px 19px;

        a {
          color: $salesflow-purple-medium !important;
        }
      }

      #lead-import-help-custom-inputs {
        font-family: 'Montserrat Medium';
        font-size: 15px;
        font-weight: 500;
        font-style: italic;
        letter-spacing: -0.18px;
        line-height: 25px;
        color: #71767D;

        a {
          color: $purple !important;
        }
      }

      .lead-import-help-inputs {
        color: $gray-light;
        font-size: 12px;
        font-weight: 400;
      }

      .lead-import-buttons-step-1 {
        margin-bottom: 0px;
      }

      .lead-import-buttons-step-2 {
        margin-bottom: 0px;
      }
    }

    input,
    select {
      background-color: white;
    }
  }

  #modal-update-leads___BV_modal_content_ {
    width: 690px;
    text-align: center;
    color: #71767D !important;
    border: none;

    p {
      font-weight: 500;
      font-size: 0.75rem !important;
      color: #71767D !important;
      line-height: 18px !important;
    }

    h5, b {
      font-weight: 700;
    }
  }

  #title-update-lead-modal {
    margin-top: 10px;
    margin-bottom: 16px;
    font-size: 1rem !important;
    line-height: 24px !important;
  }

  #modal-update-leads___BV_modal_body_ {
    background-color: #F8F8F8;
  }

  #content-update-lead-modal {
    padding: 0 1rem;
    font-size: 0.75rem !important;
    line-height: 18px;
    background-color: #F8F8F8;
  }

  #footer-update-lead-modal {
    justify-content: center;
    gap: 1.5rem;
  }

  #count-leads-update-lead-modal {
    justify-content: center;
    gap: 1rem;
  }

  #modal-update-leads___BV_modal_header_ {
    border-top-left-radius: 1rem !important;
    border-top-right-radius: 1rem !important;
  }

  #modal-update-leads___BV_modal_footer_ {
    border-bottom-right-radius: 1rem !important;
    border-bottom-left-radius: 1rem !important;
    background-color: #F8F8F8;
  }

  #button-dont-import-update-leads-modal {
    background-color: transparent;

    &:hover {
      background-color: #886AF8;
    }
  }

  .external-bordered-table {
    border: 1px solid #d1d1d1 !important;
    border-collapse: unset !important;
    border-spacing: 0 !important;

    th:first-child {
      border-top-left-radius: 1rem !important;
    }

    th:last-child {
      border-top-right-radius: 1rem !important;
    }

    thead {
      border-top: 1rem !important;
      border-top-left-radius: 1rem !important;
      border-top-right-radius: 1rem !important;
    }

    tbody {
      border-bottom: 1rem !important;
      border-bottom-right-radius: 1rem !important;
      border-bottom-left-radius: 1rem !important;
    }

    td {
      text-align: initial;
      padding-left: 15px;
    }

    th {
      font-weight: 700;
    }
  }

  .left-grey-border {
    border-left: solid 1px #D1D1D1 !important;
  }

  #table-update-lead-modal {
    border: 1px solid #d1d1d1;
    border-collapse: collapse;
    border-spacing: 0;
    display: block;
    width: 100%;

    th:first-child {
      border-top-left-radius: 1rem !important;
    }

    th:last-child {
      border-top-right-radius: 1rem !important;
    }

    thead {
      border-top: 1rem !important;
      border-top-left-radius: 1rem !important;
      border-top-right-radius: 1rem !important;
    }

    tbody {
      border-bottom: 1rem !important;
      border-bottom-right-radius: 1rem !important;
      border-bottom-left-radius: 1rem !important;
    }

    td {
      text-align: initial;
      padding-left: 15px;
    }

    th {
      font-weight: 700;
      border-top: none;
    }
  }

  #total-updating-leads-cell-update-lead-modal {
    text-align: center !important;
    color: #242424;
    font-weight: 700;
  }

  #updating-button-update-lead-modal {
    background-color: $salesflow-secondary;
  }

  #file-column-table {
   font-weight: 600;
   line-height: 18px;
   text-align: initial;
   vertical-align: middle;
  }

  #lead-field-table {
    font-weight: 400;
    line-height: 18px;
    text-align: center;
  }

  .file-header-table {
    font-weight: 700 !important;
    line-height: 18px !important;
    text-align: center !important;
    color: #242424 !important;
  }

  .info-purple-icon {
    color: #886af8;
    width: 13px;
    height: auto;
  }

  #container-primary-key-advice {
    border: 1px solid #886af8;
    border-radius: 8px;
    width: 320px;
    margin: 0 auto;
    text-align: center;
    margin-top: 0.5rem;
    margin-bottom: 1rem;
    padding: 0.5rem;
    color: #886af8;
  }

  #modal-import-fields___BV_modal_content_ {
    width: 524px;
  }

  #icon-primary-key-advice {
    font-size: 1.5rem;
  }

  .field-border-grey {
    border: 1px solid #d1d1d1;
  }

  .border-top {
    border-top: 1px solid #dee2e6 !important;
  }

  .border-top-none {
    border-top: none !important;
  }

  #container-thead-tbody-update-lead-modal {
    display: block;
    width: 100%;
    overflow: scroll;
  }

  #total-updating-leads-row-update-lead-modal {
    display: block;
    width: 100%;

    td {
      display: block;
    }
  }

  .form-group {
    input:focus {
      border-color: #886af8 !important;
    }

    select:focus {
      border-color: #886af8 !important;
    }
  }
</style>

<template>
  <div>
    <BModal
      id="modal-import-form"
      ref="modal-import-form"
      modal-class="modal-no-footer"
    >
      <template slot="modal-header">
        <div class="modal-title">
          {{ __('Importar:') }}
          <b>{{ __('Selecione seu arquivo de leads') }}</b> (1/2)
        </div>
        <button
          class="close"
          type="button"
          data-dismiss="modal"
          aria-label="Close"
          @click="$refs['modal-import-form'].hide()"
        >
          <span aria-hidden="true"><img
            class="mb-5px"
            src="/build/icons/close@white.svg"
            alt="Fechar"
            width="14"
            height="13"
          ></span>
        </button>
      </template>
      <template slot="default">
        <form v-dropzone="dropzone" />
        <div id="text-import-lead">
          <p
            class="text-center"
            id="lead-import-middle-text"
          >
            {{ __('Seu arquivo precisa ter um cabeçalho com um nome único para cada campo, de preferência') }}
            <b>{{ __('sem acentos') }}</b>.
          </p>
          <p
            class="text-center"
            id="lead-import-help"
          >
            <a
            href="https://salesflowcrm.movidesk.com/kb/article/404699/formatando-e-importando-uma-lista-de-leads-para-o-salesflow"
              target="_blank"
            >
              {{ __('Caso tenha dúvidas') }},

              <u>{{ __('clique aqui') }}</u>
              {{ __('e leia o guia para saber como formatar seu arquivo corretamente.') }}</a>
          </p>
        </div>
      </template>
      <div
        class="lead-import-buttons-step-1"
        slot="modal-footer"
      >
        <BButton
          variant="light"
          type="button"
          :disabled="saving"
          @click="$refs['modal-import-form'].hide()"
        >
          <span>{{ __('Cancelar') }}</span>
        </BButton>
      </div>
    </BModal>
    <BModal
      id="modal-import-fields"
      ref="modal-import-fields"
    >
      <template slot="modal-header">
        <div class="modal-title">
          {{ __('Importar:') }}
          <b>{{ __('Selecione seu arquivo de leads') }}</b>
        </div>
        <button
          class="close"
          type="button"
          data-dismiss="modal"
          aria-label="Close"
          @click="$refs['modal-import-fields'].hide()"
        >
          <span aria-hidden="true"><img
            class="mb-5px"
            src="/build/icons/close@white.svg"
            alt="Fechar"
            width="14"
            height="13"
          ></span>
        </button>
      </template>
      <div slot="default">
        <template v-if="tenant_primary_key">
          <div id="container-primary-key-advice">
            <i class="fa fa-info-circle icon align-middle fa-xl"
            id="icon-primary-key-advice"></i>
            <p class="pt-2 mb-2">
              <b>
                {{ __('Confirme sua chave primária ') }}
              </b>
              {{ __('para evitar duplicação dos leads na hora da importação') }}
            </p>
            <p class="mb-0">
              {{ __('Sua chave primária:') }}
              <b>
                {{ tenant_primary_key }}
              </b>
            </p>
          </div>
        </template>

        <p class="dark text-center">
          {{ __('Selecione qual CAMPO DO LEAD corresponde à coluna CAMPO DO ARQUIVO.') }}
        </p>
        <table
          id="table-container-update-lead-modal"
          class="table external-bordered-table m-t-15"
          v-show="fields.length"
        >
          <thead>
            <tr>
              <th class="border-0">
                <div class="d-flex justify-content-around">
                  <span class="file-header-table">
                    {{ __('Coluna do arquivo') }}
                  </span>
                  <i class="fa fa-info-circle icon align-middle d-flex align-items-center justify-content-center info-purple-icon"
                    v-b-tooltip.hover="{
                      customClass: 'mb-2 lead-tag-tooltip'
                    }"
                    title="Campos de cabeçalho do arquivo"
                  ></i>
                </div>
              </th>
              <th class=" border-0 left-grey-border file-header-table">
                <div class="d-flex justify-content-around">
                  <span class="file-header-table">
                    {{ __('Campo do lead') }}
                  </span>
                  <i class="fa fa-info-circle icon align-middle d-flex align-items-center justify-content-center info-purple-icon"
                    v-b-tooltip.hover="{
                      customClass: 'mb-2 lead-tag-tooltip'
                    }"
                    title="Campos de leads disponíveis no Salesflow"
                  ></i>
                </div>
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="header in file.headers">
              <td style="width: 50%" id="file-column-table">
                <span v-text="header" />
              </td>
              <td class="left-grey-border" style="width: 50%" id="lead-field-table">
                <TenantCustomFieldDropdown
                  :fields="fields"
                  add-tag="true"
                  :selected="associations[header]"
                  @select="selectField(header, $event)"
                />
              </td>
            </tr>
          </tbody>
        </table>
        <p id="lead-import-help-custom-inputs">
          {{ __('Não encontrou algum campo no lead? Crie') }}<a
            href="/settings#/custom-fields"
            target="_blank"
          >
            <u>
            {{ __('campos customizados') }}
            </u></a>
        </p>
        <div class="form-group">
          <label>{{ __('Escolha uma tag (categoria) para esta importação') }}</label>
          <input
            class="form-control field-border-grey"
            type="text"
            v-model="tag"
          >
          <p class="form-text lead-import-help-inputs">
            {{ __('Separe por vírgulas para adicionar mais de uma. Caso não escolha, uma tag automática será criada.') }}
          </p>
        </div>
        <div class="form-group">
          <label>{{ __('Escolha uma origem para esta importação') }}</label>
          <input
            class="form-control field-border-grey"
            type="text"
            v-model="origin"
          >
          <p class="form-text lead-import-help-inputs">
            {{ __('Caso não escolha, a origem será') }} &nbsp;
            {{ __('Importação') }}
          </p>
        </div>
        <div
          class="form-group"
          v-if="users.length"
        >
          <label>{{ __('Dono dos leads desta importação') }}</label>
          <select
            class="form-control field-border-grey"
            v-model="owner_id"
          >
            <option value="">
              {{ __('Selecione') }}
            </option>
            <option
              v-for="user in users"
              :value="user.id"
            >
              {{ user.first_name }} ({{ user.email }})
            </option>
          </select>
          <p class="form-text lead-import-help-inputs mb-4">
            {{ __('Caso não selecione nenhum usuário, os leads ficarão sem dono.') }}
          </p>
        </div>
        <div class="form-group">
          <p class="create-leads-radio-text">Importação de leads duplicados:</p>
          <div>
            <input
              id="create-leads"
              type="radio"
              value="create"
              name="create-or-update"
              v-model="createOrUpdateLeads"
            >
            <label class="create-leads-radio-text" for="create-leads">Não importar leads duplicados</label>
          </div>
          <div>
            <input
              id="create-and-update-leads"
              type="radio"
              value="update"
              name="create-or-update"
              v-model="createOrUpdateLeads"
            >
            <label class="create-leads-radio-text" for="create-and-update-leads">Atualizar leads existentes</label>
          </div>
          <p class="form-text lead-import-help-inputs">
            {{ __('O Salesflow automaticamente atualiza os leads que possuem a mesma chave primária. Caso sua lista tenha dados duplicados ou não queira que os leads sejam atualizados selecione a opção ') }}
            <b>"Não importar leads duplicados".</b>
          </p>
          <template v-if="tenant_primary_key">
            <p class="form-text lead-import-help-inputs">
              {{ __('Chave primária padrão') }}: &nbsp;
              {{tenant_primary_key}}
            </p>
          </template>
        </div>
      </div>
      <div
        class="col-md-12"
        slot="modal-footer"
      >
        <div class="row lead-import-buttons-step-2">
          <div class="col md-6">
            <BButton
              class="float-right"
              variant="light"
              type="button"
              :disabled="saving"
              @click="$refs['modal-import-fields'].hide()"
            >
              <span>{{ __('Cancelar') }}</span>
            </BButton>
          </div>
          <div class="col-md-6">
            <BButton
              variant="primary"
              type="submit"
              :disabled="saving"
              @click.prevent="callUpdateLeadsModal()"
              :class="{ 'loading': saving }"
            >
              <span>
                {{ __('Salvar') }}
              </span>
            </BButton>
          </div>
        </div>
      </div>
    </BModal>
    <BModal id="modal-update-leads" ref="modal-update-leads">
      <template slot="modal-header" id="header-update-modal-leads">
        <div class="modal-title">
          {{ __('Importar:') }}
          <b>{{ __('Selecione seu arquivo de leads') }}</b>
        </div>
        <button
          class="close"
          type="button"
          data-dismiss="modal"
          aria-label="Close"
          @click="$refs['modal-update-leads'].hide()"
        >
          <span aria-hidden="true"><img
            class="mb-5px"
            src="/build/icons/close@white.svg"
            alt="Fechar"
            width="14"
            height="13"
          ></span>
        </button>
      </template>
      <div slot="default" id="content-update-lead-modal">
        <h5 class="dark" id="title-update-lead-modal">
            {{ __('Atenção!') }}
        </h5>
        <p class="dark">
          {{ __('Você está importando ') }}
            <b>
              {{ updatingLeadsProcess.updatingLeads }}
            </b>
          {{ __('leads que já foram cadastrados anteriormente, verifique as informações abaixo antes de continuar.') }}
        </p>
        <div
          class="col-md-12 row lead-import-buttons-step-2"
          slot="modal-footer"
          id="count-leads-update-lead-modal"
        >
          <p id="total-lead-paragraph-update-lead-model">
            {{ __('Total de leads que serão importados: ') }}
            <b>
              {{ updatingLeadsProcess.totalLeads }}
            </b>
          </p>
          <p id="updating-lead-paragraph-update-lead-model">
            {{ __('Total de leads que serão atualizados: ') }}
            <b>
              {{ updatingLeadsProcess.updatingLeads }}
            </b>
          </p>
        </div>
        <p>
          <b>
            {{ __('Leads que serão atualizados') }}
          </b>
        </p>
        <table
          id="table-update-lead-modal"
          class="table m-t-15"
          v-show="fields.length"
        >
        <div id="container-thead-tbody-update-lead-modal">
          <thead>
              <tr class="col-12">
                <th class="col-6">{{ __('Nome')}}</th>
                <th class="col-6">{{ tenant_primary_key }}</th>
                <th class="col-6">{{ __('Empresa') }}</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="firstThreeLeadValues in updatingLeadsProcess.threeFirstLeads"  v-bind:class="(index > 0)?'border-top col-12':'border-top-none col-12'">
                <td v-for="firstThreeLeadValue in firstThreeLeadValues" class="col-4">
                  <span v-text="firstThreeLeadValue" class="text-truncate d-block" style="max-width: 164px;" v-b-tooltip.bottom="firstThreeLeadValue"/>
                </td>
              </tr>
            </tbody>
          </div>
            <tr id="total-updating-leads-row-update-lead-modal">
              <td id="total-updating-leads-cell-update-lead-modal" colspan="100%">
                +{{ updatingLeadsProcess.updatingLeadMinusThree }} {{ updatingLeadsProcess.updatingLeadMinusThree > 1 ? 'leads' : 'lead' }}
              </td>
            </tr>

        </table>
          <p class="form-text lead-import-help-inputs">
            {{ __('Você deseja atualizar as informações destes leads ou não importá-los?') }}
          </p>
      </div>
        <div
          class="col-md-12 row lead-import-buttons-step-2"
          slot="modal-footer"
          id="footer-update-lead-modal"
        >
          <BButton
              id="button-dont-import-update-leads-modal"
              class="float-right"
              variant="light"
              type="button"
              :disabled="saving"
              @click="$refs['modal-update-leads'].hide()"
            >
              <span>{{ __('Não importar duplicados') }}</span>
          </BButton>
          <BButton
              variant="primary"
              type="submit"
              :disabled="saving"
              @click.prevent="updateLeadsAndCloseUpdateModal()"
              id="updating-button-update-lead-modal"
            >
              <span v-if="saving"><i class="fa fa-circle-o-notch fa-spin" /> {{ __('Salvando...') }}</span><span v-else>{{ __('Atualizar leads') }}</span>
          </BButton>
        </div>
    </BModal>
  </div>
</template>

<script>
import { BModal, BButton } from 'bootstrap-vue';
import { VBTooltip } from 'bootstrap-vue'
import Swal from 'sweetalert2';
import { Confirm } from '../../services/Confirm';
import { Alert } from '../../services/alert';

export default {
  components: {
    BModal,
    BButton,
  },

  props: {
    tenant_primary_key: {
      type: String,
      required: true,
    }
  },

  directives: {
    'b-tooltip': VBTooltip,
  },

  store: ['users'],

  mounted () {
    Bus.$on('importLeadButtonToggled', () => this.open());
    Bus.$on('stagesRetrieved', (stages) => (this.stages = stages));
    Bus.$on('fieldsRetrieved', (fields) => (this.fields = fields));

    this.$root.$on('bv::modal::hide', (event, modalId) => {
      if (event.trigger == 'fileuploaded' && modalId == 'modal-import-form') {
        this.loading = false;

        this.$refs['modal-import-fields'].show();
      }
    });
  },

  data () {
    return {
      updatingLeadsProcess: {
        updatingLeads: '',
        totalLeads:'',
        updatingLeadMinusThree: '',
        threeFirstLeads: []
      },
      file: {
        name: null,
        headers: null,
      },
      tag: null,
      origin: null,
      fields: [],
      hashImport: '',
      stage_id: '',
      owner_id: '',
      stages: [],
      saving: false,
      associations: {},
      fieldOptions: [],
      dropzone: {
        defaultMessage: this.__('Clique aqui ou arraste seu arquivo CSV para iniciar'),
        action: '/lead/csv/import',
        faIcon: 'fa-plus',
        success: this.fileUploadedCallback,
        error: this.fileUploadedError,
        keepFiles: false,
      },
      createOrUpdateLeads: 'update',
      customField: {
        showModal: false,
        header: null,
        previousValue: '',
      },
    };
  },

  methods: {
    open () {
      this.$refs['modal-import-form'].show();
    },

    fileUploadedError (e) {
      Alert.error(
        this.__('Erro: Verifique se seu arquivo CSV possui cabeçalhos únicos e tem menos de 10 MB.'),
      );
    },

    fileUploadedCallback (e) {
      this.resetAssociations();
      this.loading = true;

      this.file.name = e.name;
      const data = JSON.parse(e.xhr.response);
      this.file.headers = data.headers;
      this.hashImport = data.hashImport;

      this.suggestAssociations();

      this.$refs['modal-import-form'].hide('fileuploaded');
    },

    suggestAssociations () {
      for (const i in this.file.headers) {
        const headerName = this.file.headers[i];
        const headerNameEncoded = this.encodeString(headerName);

        for (const j in this.fields) {
          const field = this.fields[j];
          const labeledFieldNameEncoded = this.encodeString(field.description);

          this.associations[headerName] = '';

          if (
            this.likeness(headerNameEncoded, field.identifier) >= 50
            || this.likeness(headerNameEncoded, labeledFieldNameEncoded) >= 50
          ) {
            this.associations[headerName] = field.identifier;

            break;
          }
        }
      }
    },

    encodeString (str) {
      str = window.encodeURI(str || '');
      str = str.replace(/[`~!@#$%^&*()_|+\-=?;:'",.<>\{\}\[\]\\\/]/gi, '');
      return str.toLowerCase();
    },

    likeness (str1, str2) {
      if (! str1 || ! str2) {
        return 0;
      }

      let equals = 0;
      for (const i in str1) {
        if (str2[i] && str2[i] === str1[i]) {
          equals++;
        }
      }

      return (equals * 100) / str1.length;
    },

    async callUpdateLeadsModal() {
      const selectedOption = this.createOrUpdateLeads === 'create' ?
        'Não importar leads duplicados' : 'Atualizar leads existentes';

      if (! await Confirm(
        this.__('Deseja importar estes dados?'),
         '',
         '<div>'
         + '<span>Importação de leads duplicados:</span>'
         + `<div><i class="check-icon fa fa-check"></i><span>${selectedOption}</span></div>`
         + '</div>',
         'container-swal2 lead-import-confirm-modal'
      )) {
        return;
      }

      this.saving = true;

      try {
        await this.save(this.createOrUpdateLeads);

        this.saving = false;
      } catch (error) {
        this.saving = false;

        console.error(error);

        Alert.error(
          this.__('Não foi possível realizar a sua importação.'),
        );
      }

      this.resetUpdateLeadsValues();

      // if (this.duplicates) {
      //   return;
      // }

      // try {
      //   const { body } = await this.$http.get('/lead/csv/details');

      //   if (body.total_leads_updated ) {
      //     this.updatingLeadsProcess.totalLeads = body.total_leads_imported;
      //     this.updatingLeadsProcess.updatingLeadMinusThree = body.updated_leads_minus_three;
      //     this.updatingLeadsProcess.updatingLeads = body.total_leads_updated;
      //     body.first_three_leads.forEach(objects => this.updatingLeadsProcess.threeFirstLeads.push(Object.values(objects)));

      //     console.log('body.first_three_leads.forEach(objects => this.updatingLeadsProcess.threeFirstLeads.push(Object.values(objects)))', this.updatingLeadsProcess.threeFirstLeads);

      //     this.$refs['modal-update-leads'].show();
      //   }

      //   this.$refs['modal-import-fields'].hide();

      // } catch (error) {
      //   console.error(error);

      //   Alert.error(this.__('Não foi possível capturar os dados dessa importação.'));
      // }
    },

    resetUpdateLeadsValues() {
      this.updatingLeadsProcess.totalLeads = '';
      this.updatingLeadsProcess.updatingLeadMinusThree = '';
      this.updatingLeadsProcess.updatingLeads = '';
      this.updatingLeadsProcess.threeFirstLeads = [];
    },

    async save (method) {
      this.saving = true;

      const data = {
        tag: this.tag,
        origin: this.origin,
        stage_id: this.stage_id,
        owner_id: this.owner_id,
        associations: this.associations,
        hashImport: this.hashImport,
      };

      await this.$http.put(`/lead/csv/import/${method}`, data)
        .then((response) => {
          this.saving = false;

          this.notifyImport(response.body.importQuantity, true);

          this.$refs['modal-import-fields'].hide();
        })
        .catch((error) => {
          this.saving = false;

          console.error(error);

          if (error?.status === 422) {
            Alert.error(
              this.__('Erro ao importar dados, verifique se o arquivo importado possui chave primária.'),
            );
          } else {
            Alert.error(
            this.__('Erro ao importar dados, verifique o formato do seu arquivo.'),
          );
          }
        });
    },

    resetAssociations() {
      this.associations = {};
    },

    updateLeadsAndCloseUpdateModal() {
      this.$refs['modal-update-leads'].hide();
      this.save('update');
    },

    selectField (header, value) {
      this.associations[header] = value;
    },

    notifyImport(importQuantity, inProgress = false) {
      let message = inProgress ? this.__('Total de leads em importação: ') + importQuantity : this.__('Total de leads importados: ') + importQuantity
      Swal.fire({
          icon: 'success',
          iconColor: '#2CEBA9',
          html:  `<div style="font-size:16px; font-family:Montserrat; color:#71767D; font-weight:bold; line-height:24px;">${this.__('Importação de leads em andamento!')}</div>`
                + `<div style="font-size:12px; font-family:Montserrat; color:#71767D; gap:24px; font-weight:600;" class="mt-4">${message}</div>`
                + `<div style="font-size:12px; font-family:Montserrat; line-height:18px" class="mt-4">${this.__('Após a conclusão da importação, você receberá um e-mail informando que os leads foram importados com sucesso.')}</div>`,
          buttonsStyling: false,
          allowOutsideClick: false,
          confirmButtonText: this.__('Concluir'),
          customClass: {
            container:'container-swal2-import-csv',
            confirmButton: 'btn btn-primary'
          }
      });
    },
  },
};
</script>
